import { render, staticRenderFns } from "./Fournisseur.vue?vue&type=template&id=02a5f408&lang=true"
import script from "./Fournisseur.vue?vue&type=script&lang=js"
export * from "./Fournisseur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports